import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Alert,
    Button,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
import { setModal } from '../../../../../Common/App';
import { DialogCard, Loader } from '../../../../../../Components';
import { addLocation, updateLocation } from '../../../Redux/Action';

export const LocationModal = ({ venue, item }) => {

    const dispatch = useDispatch();
    const [disabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({
        id: null,
        venue_id: '',
        location_name: '',
        code: '',
        notes: '',
        sort_order: 0,
        is_active: true,
    });

    useEffect(() => {
        if (item) {
            setData({
                id: item.id,
                venue_id: item.venue_id || '',
                location_name: item.location_name || '',
                code: item.code || '',
                notes: item.notes || '',
                sort_order: item.sort_order ?? 0,
                is_active: item.is_active !== false && item.is_active !== 0,
            });
        } else if (venue?.id) {
            setData((prev) => ({
                ...prev,
                id: null,
                venue_id: venue.id,
                location_name: '',
                code: '',
                notes: '',
                sort_order: 0,
                is_active: true,
            }));
        }
    }, [item, venue]);

    const handleSaveOrUpdate = async () => {

        if (!data.venue_id) {
            setErrors({ venue_id: 'Venue is required' });
            setMessage('Venue is required');
            return;
        }

        if (!data.location_name.trim()) {
            setErrors({ location_name: 'Location name is required' });
            setMessage('Location name is required');
            return;
        }

        setIsLoading(true);
        const payload = {
            venue_id: data.venue_id,
            location_name: data.location_name.trim(),
            code: data.code?.trim() || null,
            notes: data.notes?.trim() || null,
            sort_order: data.sort_order === '' || data.sort_order === null || typeof data.sort_order === 'undefined'
                ? 0
                : (Number.isFinite(Number(data.sort_order)) ? Number(data.sort_order) : 0),
            is_active: !!data.is_active,
        };

        if (data.id) {
            payload.id = data.id;
            await updateLocation({ dispatch, data: payload }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    dispatch(setModal({ component: null, open: false }));
                } else {
                    setErrors(res.errors || {});
                    setMessage(res.message || '');
                }
            });
        } else {
            await addLocation({ dispatch, data: payload }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    dispatch(setModal({ component: null, open: false }));
                } else {
                    setErrors(res.errors || {});
                    setMessage(res.message || '');
                }
            });
        }
    };

    const handleChange = (e) => {
        setErrors({});
        setMessage('');
        const { name, value, checked, type } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const venueLabel = venue?.venue_name || '—';

    return (
        <DialogCard>
            <CardHeader
                title={data.id ? 'Edit Location' : 'Add Location'}
                avatar={<Loader isLoading={isLoading} type="linear" />}
            />
            <CardContent>
                {message && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {message}
                    </Alert>
                )}
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            Venue: <strong>{venueLabel}</strong>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Location name"
                            name="location_name"
                            value={data.location_name}
                            onChange={handleChange}
                            error={!!errors.location_name}
                            helperText={errors.location_name}
                            disabled={disabled}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Code"
                            name="code"
                            value={data.code}
                            onChange={handleChange}
                            error={!!errors.code}
                            helperText={errors.code}
                            disabled={disabled}
                        />
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Sort order"
                            name="sort_order"
                            value={data.sort_order}
                            onChange={handleSortOrderChange}
                            error={!!errors.sort_order}
                            helperText={errors.sort_order}
                            disabled={disabled}
                            type="number"
                            inputProps={{ min: 0 }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={(
                                <Switch
                                    checked={!!data.is_active}
                                    onChange={handleActiveChange}
                                    disabled={disabled}
                                    color="primary"
                                />
                            )}
                            label="Active"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Notes"
                            name="notes"
                            value={data.notes}
                            onChange={handleChange}
                            error={!!errors.notes}
                            helperText={errors.notes}
                            disabled={disabled}
                            multiline
                            minRows={2}
                        />
                    </Grid> */}
                </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end' }}>
                <Button
                    variant="outlined"
                    onClick={() => dispatch(setModal({ component: null, open: false }))}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSaveOrUpdate}
                    disabled={isLoading || disabled}
                >
                    {isLoading ? 'Saving...' : (data.id ? 'Update' : 'Add')}
                </Button>
            </CardActions>
        </DialogCard>
    );
};
